<div class="col-md-12" *ngIf="html" [innerHTML]="html | safe:'html'"></div>